import { useApiQuery } from '../useApiQuery';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import type { LeadActivity } from '@/types/lead';

interface LeadActivityResponse {
  data: LeadActivity[];
  total: number;
  page: number;
  limit: number;
}

export function useLeadActivity(leadId: string) {
  return useApiQuery<LeadActivity[]>({
    queryKey: [...leadKeys.detail(leadId), 'activity'],
    queryFn: async () => {
      const res = await apiGet<LeadActivityResponse>(
        operationsClient,
        leadEndpoints.activities(leadId),
      );
      return res.data;
    },
    enabled: Boolean(leadId),
    showErrorToast: false,
  });
}
